module.exports = __webpack_public_path__ + "static/alpine-spas-e032c276d195e3903776057f984973a4.png";